import { withNamespaces } from "react-i18next";

import * as pages from "./pages";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { useSelector } from "react-redux";

import "antd/dist/antd.min.css";

const App = ({ t }) => {
  const { auth } = useSelector((state) => state);
  console.log(auth.user);

  return (
    <>
      <Router>
        <Routes>
          <Route path="auth/*" element={<pages.Auth />} />
          <Route
            path="profile"
            element={auth.user ? <pages.Profile /> : <pages.Auth />}
          />
          <Route path="/" element={<pages.LandingPage />} />
          <Route path="*" element={<pages.NotFound />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default withNamespaces()(App);
